import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {Charts} from 'shared/dtos/cockpit/charts/charts';
import {SeriesAbsolutPerc} from 'shared/dtos/cockpit/charts/seriesAbsolutPerc';
import {Cockpit} from 'shared/dtos/cockpit/cockpit';
import {PersonenUndStellenbezogeneMerkmale} from 'shared/dtos/cockpit/personen-und-stellenbezogene-merkmale';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {CockpitContentComponent} from '../../cockpit-shared/cockpit-content-component';
import {CurrentLocaleComponent} from 'shared/components/current-locale-component';

@Component({
  selector: 'app-personen-stellenbezogene-merkmale',
  templateUrl: './personen-stellenbezogene-merkmale.component.html',
  styleUrls: [
    './personen-stellenbezogene-merkmale.component.scss',
    '../../cockpit-shared/card/card.component.scss'
  ],
  standalone: false
})
export class ChartDialogPersonenStellenbezogeneMerkmaleComponent
  extends CurrentLocaleComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  chart: Highcharts.Chart;

  tableHeaders = [
    'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.drchschnittswerteErklärungsmerkmale',
    'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.anteileErklärungsmerkmale',
    'i18n.cockpit.card.chart.beruflicherStellung.title'
  ];

  seriesKompetenzniveau: SeriesAbsolutPerc;
  seriesBeruflicheStellung: SeriesAbsolutPerc;
  personenStellenbezogeneMerkmale: PersonenUndStellenbezogeneMerkmale;

  constructor(
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService,
    protected readonly translate: TranslateService
  ) {
    super(translate);
    this.personenStellenbezogeneMerkmale =
      new PersonenUndStellenbezogeneMerkmale();
  }

  async ngOnInit() {
    super.ngOnInit();
    this.storage.getChartsData().then((data: Charts) => {
      this.seriesKompetenzniveau =
        data.personenUndStellenbezogeneMerkmale.nachKompetenzniveau;
      this.seriesBeruflicheStellung =
        data.personenUndStellenbezogeneMerkmale.nachBeruflicheStellung;
    });

    this.storage.getCockpitData().then(data => {
      this.personenStellenbezogeneMerkmale = (
        data as Cockpit
      ).personenUndStellenbezogeneMerkmale;
    });
  }

  exportChart() {
    this.chart.exportChart(
      {
        type: 'application/pdf',
        filename: 'my-pdf'
      },
      {}
    );
  }

  exportTable(id: string, headerIndex: number) {
    this.tableExport.exportHtmlTable(id, this.tableHeaders[headerIndex]);
  }

  get isAllAnf(): boolean {
    return (
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau5MaennerAnzahl > 0 ||
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau5FrauenAnzahl > 0 ||
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau6MaennerAnzahl > 0 ||
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau6FrauenAnzahl > 0 ||
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau7MaennerAnzahl > 0 ||
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau7FrauenAnzahl > 0 ||
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau8MaennerAnzahl > 0 ||
      this.personenStellenbezogeneMerkmale
        .betrieblichesKompetenzniveau8FrauenAnzahl > 0
    );
  }
}
